import { render, staticRenderFns } from "./GroupTemplateSelectionSidebar.vue?vue&type=template&id=20ae79f0&"
import script from "./GroupTemplateSelectionSidebar.vue?vue&type=script&lang=js&"
export * from "./GroupTemplateSelectionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GroupTemplateSelectionSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports